import { render, staticRenderFns } from "./AskingStickersFormComponent.vue?vue&type=template&id=475bc180&"
import script from "./AskingStickersFormComponent.vue?vue&type=script&lang=js&"
export * from "./AskingStickersFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./AskingStickersFormComponent.vue?vue&type=style&index=0&id=475bc180&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports